const vendor_terms_conditions = [
    {
        id: 'Platform Usage and Vendor Responsibility',
        title: '1. Platform Usage and Vendor Responsibility',
        content: `Vendors acknowledge that they are listed on the platform solely for the purpose of increasing visibility among potential customers. Each vendor is responsible for creating and maintaining their own profile with accurate, up-to-date information. Any misrepresentation, including but not limited to falsified identity or portfolio, will be the sole responsibility of the vendor. The platform shall not be held liable for any such misrepresentation.
    \nVendors understand and agree that any engagement or transaction with customers is undertaken independently. The platform functions purely as a listing and discovery service and does not act as a party to any agreement or transaction between the vendor and the customer. Vendors are expected to uphold high standards of service quality and refrain from any form of deception.

    `,
    },
    {
        id: 'Intellectual Property',
        title: '2. Intellectual Property',
        content: `Vendors must not use content, including photographs or other media, that they do not own or have rights to. Any use of third-party content presented as their own is strictly prohibited and will be the sole liability of the vendor.
    `,
    },
    {
        id: 'Commercial Relationships and Promotions',
        title: '3. Commercial Relationships and Promotions',
        content: `The platform may engage in commercial partnerships with certain vendors, which may include, but are not limited to, paid promotions and increased visibility in exchange for a fee. Such promotional features do not guarantee business or bookings. The platform’s role remains that of a facilitator, connecting vendors to a broader audience.
    `,
    },
    {
        id: 'Vendor Reviews',
        title: '4. Vendor Reviews',
        content: `Reviews play an important role in customer decision-making and vendor reputation. To ensure credibility:
- Vendors may request clients to leave reviews directly on their profile or email them to the platform for posting.
- Reviews must be genuine. Soliciting reviews in exchange for incentives or from relatives, team members, or non-clients is prohibited.
- Vendors may report suspicious or false reviews to the platform. Upon review, the platform will contact the vendor within 48 hours and may request supporting documentation. If proof is not provided within 7 days, the report will be considered closed.
- If the review is verified as inauthentic, it will be removed, and relevant parties will be notified.
- Vendors are encouraged to respond professionally to negative reviews. Balanced feedback, including a vendor’s side of the story, is valued by users.

    `,
    },
    {
        id: 'Vendor Profile Deletion',
        title: '5. Vendor Profile Deletion',
        content: `Vendor profiles cannot be permanently deleted upon request. At the platform’s discretion, profiles may be marked as "unclaimed" and made unsearchable. Profiles may also be created by the platform based on user-submitted reviews or other data, even without prior vendor consent. These profiles will be labeled as unclaimed or unverified until further details are provided.

    `,
    },
    {
        id: 'Third-Party Collaborations',
        title: '6. Third-Party Collaborations',
        content: `Vendors may participate in third-party promotions or campaigns (e.g., product discounts via partners such as Nykaa). Such engagements are governed by the respective third party’s terms and conditions. Vendors agree to use these benefits strictly for providing services to end clients.
    `,
    },
    {
        id: 'User Disputes',
        title: '7. User Disputes',
        content: `The platform is not responsible for any interactions, disputes, or transactions between users, including vendors and customers. While the platform may choose to monitor or intervene in disputes at its sole discretion, it is under no obligation to do so.
        \nVendor profile data, such as prices, images, and reviews, are based on inputs from vendors and their clients. While reasonable efforts are made to verify such information, the platform does not guarantee its accuracy.
    `,
    },
    {
        id: 'Privacy Policy',
        title: '8. Privacy Policy',
        content: `All platform activities are subject to the Privacy Policy available at [Your Website]/privacy, which is hereby incorporated into these terms.
    `,
    },
    {
        id: 'Promotions and Giveaways',
        title: '9. Promotions and Giveaways',
        content: `Occasionally, the platform may host giveaways or promotions on behalf of third parties. Each campaign will have specific terms outlining data usage and sharing. Vendors are advised to read such terms before participating. The platform assumes no responsibility for these third-party activities.
    `,
    },
    {
        id: 'Disclaimer of Warranties',
        title: '10. Disclaimer of Warranties',
        content: `The platform and its services are provided “as is” and “as available” without any warranties, express or implied. The platform disclaims all warranties, including fitness for a particular purpose, non-infringement, or uninterrupted access. Users are encouraged to exercise discretion and good judgment when using the platform.
    `,
    },
    {
        id: 'Limitation of Liability',
        title: '11. Limitation of Liability',
        content: `To the maximum extent permitted by law, the platform shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from the use of its services. Liability, if any, is limited to the amount paid by the user for the service during their usage term.
    `,
    },
    {
        id: 'International Use',
        title: '12. International Use',
        content: `Vendors agree to comply with all local laws regarding online conduct and acceptable content. This includes compliance with export regulations related to the transmission of data.
    `,
    },
    {
        id: 'Governing Law and Jurisdiction',
        title: '13. Governing Law and Jurisdiction',
        content: `All disputes shall be governed by the laws of India, and the courts located in Hyderabad or New Delhi shall have exclusive jurisdiction over any matters arising out of or related to these terms.
    `,
    },
    {
        id: 'Indemnification',
        title: '14. Indemnification',
        content: `Vendors agree to indemnify and hold the platform and its affiliates harmless from any claims, damages, liabilities, or legal fees arising out of their breach of these terms or any third-party rights.
    `,
    },
    {
        id: 'Waiver and Severability',
        title: '15. Waiver and Severability',
        content: `Any failure to enforce a provision does not constitute a waiver. If any provision is deemed invalid, the remaining terms shall remain in effect.
    `,
    },
    {
        id: 'Statute of Limitations',
        title: '16. Statute of Limitations',
        content: `Any claims arising from the use of the platform must be initiated within one (1) year from the date the issue arises or they will be deemed permanently waived.
    `,
    },
    {
        id: 'Reporting Violations',
        title: '17. Reporting Violations',
        content: `Suspected violations of these terms may be reported via email .
    `,
    },


]


export default vendor_terms_conditions;